export enum NavigationDefaults {
  // stale time = 5 min
  StaleTime = 30 * 10000,
  // cache time = 30 min
  GcTime = 180 * 10000,
}
